import React from 'react';
import { formatDisplayDate } from '../../../utils';

export interface DateTimeCellProps {
  date: string;
  timeRange?: string;
  /** Makes the cell an interactive trigger (e.g. opening a fulfillment drawer). Omit to render a plain, non-interactive cell — AllOrdersTable's date cell relies on this default. */
  onClick?: () => void;
  /** Reflected as `aria-expanded` on the trigger opened by `onClick`; ignored when `onClick` is omitted. */
  isOpen?: boolean;
}

export const DateTimeCell: React.FC<DateTimeCellProps> = ({ date, timeRange, onClick, isOpen }) => {
  const content = (
    <>
      <span className="sui-block sui-whitespace-nowrap">{formatDisplayDate(date, { includeYear: true })}</span>
      {timeRange ? <span className="sui-block sui-whitespace-nowrap">{timeRange}</span> : null}
    </>
  );

  if (!onClick) {
    return <span className="sui-flex sui-flex-col sui-text-sm sui-text-subtle">{content}</span>;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      aria-haspopup="dialog"
      aria-expanded={Boolean(isOpen)}
      className="sui-flex sui-flex-col sui-text-sm sui-text-subtle sui-underline"
    >
      {content}
    </button>
  );
};
